module.exports = __webpack_public_path__ + "img/cert.22f754bb.png";